const PaymentList = () => {
  return <div>Payments</div>;
};
export default PaymentList;
